export default "__VITE_ASSET__C8nYVPnw__"